/**
 * CSM Staffing feature routes.
 *
 * Root redirects to Overview — the tier model is the thing you set before the
 * portfolios it produces mean anything.
 */
import { Navigate, Route } from 'react-router';
import type { FeatureRouteList } from '@/features/routes-registry';
import { CsmStaffingLayout } from './CsmStaffingLayout';
import StaffingOverviewPage from './pages/overview/page';
import StaffingPortfoliosPage from './pages/portfolios/page';
import StaffingTeamPage from './pages/team/page';

export const csmStaffingRoutes: FeatureRouteList = [
  <Route element={<CsmStaffingLayout />} key="csm-staffing" path="csm-staffing">
    <Route
      element={<Navigate replace to="/csm-staffing/overview" />}
      index
      key="csm-staffing-index"
    />
    <Route
      element={<StaffingOverviewPage />}
      key="csm-staffing-overview"
      path="overview"
    />
    <Route
      element={<StaffingPortfoliosPage />}
      key="csm-staffing-portfolios"
      path="portfolios"
    />
    <Route element={<StaffingTeamPage />} key="csm-staffing-team" path="team" />
  </Route>,
];
